import React from "react";

export const useUrlParams = () => {
    const getUrlParam = React.useCallback((param: string) => {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(param);
    }, []);

    const setUrlParams = React.useCallback(
        (params: { [key: string]: Maybe<string> }): void => {
            // get existing params
            const originalParams = Object.fromEntries(
                new URLSearchParams(window.location.search)
            );

            // update params with new query value
            const newParams = {
                ...originalParams,
                ...params,
            };

            // remove any entries where the value is falsy
            const filteredParams = Object.entries(newParams)
                .filter((kvPair) => Boolean(kvPair[1]))
                .reduce(
                    (prev, [key, value]) => ({ ...prev, [key]: value }),
                    {}
                );

            let newUrl = window.location.href.split("?")[0];

            if (Object.keys(filteredParams).length > 0) {
                newUrl = `${newUrl}?${new URLSearchParams(
                    filteredParams
                ).toString()}`;
            }

            // set new URL (won't trigger reload)
            window.history.replaceState("", "", newUrl);
        },
        []
    );

    return { getUrlParam, setUrlParams };
};
